<template>
	<v-container
		class="brightBackground"
		fluid
		style="min-height: 100%"
	>
		
		<v-container fluid style="max-width: 1000px;" class="pt-xs-0 pt-sm-0 pt-md-0 pt-lg-6">

			<v-row>

				<v-col class="pt-0 pa-0 ma-0">
					
					<v-subheader class="display-1 font-weight-bold ml-0 pl-1 pb-0 grey--text text--darken-3">Clients</v-subheader>

					<v-toolbar
						dense
						flat
						color="toolbarSecondary"
					>
						<v-btn
							color="iconTextColor"
							text
							small
							style="text-transform: none;"
							class="ml-n4"
							height="32"
							router to="/admin/newclient"
						>
							<v-icon medium>mdi-account-plus</v-icon>
							<span class="ml-2">New client</span>
						</v-btn>

					</v-toolbar>


					<!-- -------------------------------------------- -->
					<!--   Expansion panel -->
					<!-- -------------------------------------------- -->

					<v-expansion-panels multiple>

						<v-expansion-panel v-for="(client, i) in clients" :key="i">

							<!-- Expanded panel header-->
							<v-expansion-panel-header color="grey lighten-4 primary--text text--darken-1">
								<b>{{ client.name }}</b>
							</v-expansion-panel-header>

							<!-- Expanded panel -->
							<v-expansion-panel-content>
								<v-container fluid class="pt-6 pb-0 px-1">

									<v-row>
										<v-col cols="12" xs="12" sm="12" md="12" xl="12" class="px-3 pb-0">
											<v-text-field
												label="Client name"
												v-model="client.name"
												outlined
												dense
											></v-text-field>
										</v-col>
									</v-row>

									<v-row>
										<v-col cols="6" xs="12" sm="12" md="8" xl="8" class="px-3 pb-0">
											<v-text-field
												label="Client variable name"
												v-model="client.variable"
												outlined
												dense
												
											></v-text-field>
										</v-col>

										<v-col cols="6" xs="12" sm="12" md="4" xl="4" class="px-3 pb-0">
											<v-text-field
												label="Client key"
												v-model="client.prefix"
												disabled
												outlined
												dense
												
											></v-text-field>
										</v-col>                                      
									</v-row>

									<v-row class="mb-n3">
										<v-col align="right">
											<icon-text-button b-icon="mdi-delete" @click="deleteClient(client)">Delete client</icon-text-button>
											<icon-text-button b-icon="mdi-content-save" @click="saveClient(client)">Save changes</icon-text-button>
										</v-col>
									</v-row>
								
								</v-container>
							</v-expansion-panel-content>
						</v-expansion-panel>

					</v-expansion-panels>

				</v-col>
			</v-row>
			
		</v-container>

	</v-container>
</template>



<script>

// ----------------------------------------------------
//
//  Main script
//
// ----------------------------------------------------

import agile from '@/shift/agile';
import fb from '@/shift/fb';

export default
{
	name: 'Clients',

	// ----------------------------------
	//	VUE: Data and computed
	// ----------------------------------

	data: () =>
	({
		clients: [],
		firestoreLiveConnection: null,
	}),

	computed:
	{
		agile()
		{
			return agile;
		},
	},


	// ----------------------------------------------------
	//
	//  VUE: Create and Mount
	//
	// ----------------------------------------------------

	created()
	{

		// ----------------------------------
		//	Load client list and let it
		//  live reload!
		// ----------------------------------
		
		this.firestoreLiveConnection = fb.db.collection('clients').onSnapshot(res =>
		{
			const changes = res.docChanges();

			changes.forEach(change =>
			{

				// ----------------------------------
				//	Content added
				// ----------------------------------

				if (change.type === 'added')
				{
					this.clients.push(
					{
						...change.doc.data(),
						id: change.doc.id
					})
				}


				// ----------------------------------
				//	Content modified
				// ----------------------------------

				if (change.type === "modified")
				{
					for (let i = 0; i < this.clients.length; i++)
					{
						if (this.clients[i].id == change.doc.id)
						{
							var uD = change.doc.data();
							this.clients[i].name = uD.name;
							this.clients[i].variable = uD.variable;
							this.clients[i].prefix = uD.prefix;
							this.clients[i].id = change.doc.id;
						}
					}
				}


				// ----------------------------------
				//	Content deleted
				// ----------------------------------

				if (change.type === "removed")
				{
					for (let i = 0; i < this.clients.length; i++)
					{
						if (this.clients[i].id == change.doc.id)
						{
							this.clients.splice(i, 1);
						}
					}
				}
			});

			// ----------------------------------
			//	Sort alphabetically by name
			// ----------------------------------

			this.agile.sortBy(this.clients, 'name');

		},
		er =>
		{
			this.$root.$alert("Error", er.message);
		});

	},

	mounted()
	{
		
	},


	// --------------------------------------------------------------------
	//
	//	VUE: Methods
	//
	// --------------------------------------------------------------------

	methods:
	{

		// ----------------------------------
		//	Save client data
		// ----------------------------------
		
		saveClient(client)
		{
			
			// Todo: Validate god damn it

			this.$root.$confirm('Careful', 'Changes in these settings can break project code and user access. Still want to change?', { color: 'warning' } )
			.then((confirm) =>
			{
				if (confirm)
				{
					// ----------------------------------
					//	Save client in Firebase
					// ----------------------------------

					fb.db.collection("clients").doc(client.id).update(
					{
						name: client.name,
						variable: client.variable,
						//prefix: client.prefix.toLowerCase(),
					})
					.then(() =>
					{
						this.$root.ai_app.snackbarText = 'Client updated';
						this.$root.ai_app.snackbarTimeout = 3000;
						this.$root.ai_app.snackbar = true;
					})
					.catch((error) =>
					{
						this.$root.$alert("Error", error.message);
					});
				}
			});
		},


		// ----------------------------------
		//	Delete client
		//  Todo: Should only delete if
		//        no group/projects are
		//        assigned.
		// ----------------------------------

		deleteClient(client)
		{
			
			this.$root.$confirm('Careful', 'Deleting clients will make all groups and projects for this client orphans. Still want to delete?', { color: 'warning' } )
			.then((confirm) =>
			{
				if (confirm)
				{
					fb.db.collection("clients").doc(client.id).delete()
					.then(() =>
					{
						this.$root.ai_app.snackbarText = 'Client deleted';
						this.$root.ai_app.snackbarTimeout = 3000;
						this.$root.ai_app.snackbar = true;
					})
					.catch((error) =>
					{
						this.$root.$alert("Error", error.message);
					});
				}
			});

		},
		
	},



	// --------------------------------------------------------------------
	//
	//	VUE: Destroy event hook
	//
	// --------------------------------------------------------------------
	
	beforeDestroy()
	{
		// Unsubscribe live listener
		this.firestoreLiveConnection();
	},



}
</script>